import { defineComponent } from 'vue'
import classNames from 'classnames'
import './PaginationLayout.scss'

export const PaginationLayout = defineComponent({
  name: 'PaginationLayout',
  inheritAttrs: false,
  setup(_props, { slots, attrs }) {
    return () => (
      <div {...attrs} class={classNames('pagination-layout', attrs.class as string)}>
        {slots.default?.()}
      </div>
    )
  },
})
